import { css } from 'lit';
export const style = css`
  :host {
    --one-ux-visualization-element--min-number-of-lines: 0;

    vertical-align: top;
  }

  :host([shape='bar']) {
    min-width: 160px;
  }

  .one-ux-element--root {
    display: flex;
    flex-direction: column;
    outline: none;
    justify-content: center;
    padding: var(--one-ux-spacing--200) var(--one-ux-spacing--300);
    border-radius: var(--one-ux-radius--300);
  }

  :host([compact]) .one-ux-element--root {
    padding: 0;
  }

  :host(:not([implicit]):not([static]):hover) .one-ux-element--root {
    background: rgba(var(--one-ux-rgb--brand-neutral-500), 0.09);
  }

  :host([state-keyboard-focus]:focus) .one-ux-element--root {
    box-shadow: inset 0 0 0 2px var(--one-ux-palette--keyboard-focus-400);
    background: var(--one-ux-palette--keyboard-focus-100);
  }

  .summary {
    color: var(--one-ux-palette--brand-neutral-600);
  }

  .description {
    color: var(--one-ux-palette--brand-neutral-500);
  }

  svg {
    flex: 1 1 auto;
    cursor: default;
    vertical-align: top;
  }

  .arcShape {
    --one-ux-indication--aspect-ratio: var(--one-ux-indication--arc-aspect-ratio);

    gap: var(--one-ux-spacing--100);
  }

  .barShape {
    --one-ux-indication--aspect-ratio: auto;
  }

  .arcShape,
  .barShape {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  :host([weight='high']) .barShape {
    gap: var(--one-ux-spacing--400);
  }

  .arcShape .svgAndSlots {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 0;
  }

  .svgAndSlots {
    /* Safari does not handle "aspect-ratio: inherit" correctly on svg child
       so we need to sync ratio between parent and child element. 
       See issue: https://github.com/stratsys/PDR.Package/issues/1402 */
    aspect-ratio: var(--one-ux-indication--aspect-ratio);

    svg {
      aspect-ratio: var(--one-ux-indication--aspect-ratio);
    }
  }

  :host([weight='low']) .arcShape .svgAndSlots {
    flex-direction: row;
    gap: var(--one-ux-spacing--300);
  }

  .arcShape .innerSlots {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-direction: column;
    text-align: center;
    overflow-wrap: break-word;
  }

  .arcShape .outerSlots {
    display: flex;
    flex-direction: column;
  }

  :host([weight='normal']) .arcShape .description {
    line-height: 1;
  }

  .barShape .slotsAndLegend {
    display: flex;
    align-items: center;
    gap: var(--one-ux-spacing--300);
    width: 100%;
    justify-content: space-between;
  }

  :host([weight='high']) .barShape .slotsAndLegend {
    align-items: baseline;
  }

  :host([weight='high']) .barShape .slots {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
  }

  :host(:is([weight='normal'], [weight='low'])) .barShape .description {
    color: var(--one-ux-palette--brand-neutral-600);
  }
`;